<template>
  <div class="file-input">
    <voxy-button id="file-input-choose-file-button" class="file-input__button" size="s">
      Choose file
      <input id="file-input__input" class="file-input__input" type="file" @change="onFileSelected" />
    </voxy-button>
    <span class="file-input__filename" v-if="file.name">{{ file.name }}</span>
    <span class="file-input__empty" v-else>{{ noFileText }}</span>
  </div>
</template>

<script>
import { VoxyButton } from '@voxy-team/vue-voxy';

export default {
  name: 'FileInput',

  components: {
    VoxyButton,
  },

  props: {
    value: {
      default: () => ({}),
      type: [File, Object],
    },
  },

  data() {
    return {
      file: {},
      noFileText: 'No file chosen',
    };
  },

  methods: {
    onFileSelected(event) {
      this.file = event.target.files[0] || {};
      this.$emit('input', this.file);
    },
  },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.file-input {
  font-size: 1.25rem;
  position: relative;
  color: $default-grey;

  &__button {
    position: relative;
    margin-right: 30px;
  }

  &__input {
    position: absolute;
    z-index: 100;
    opacity: 0;
    top: -3px;
    left: -3px;
    min-width: 100%;
    min-height: 100%;
    width: calc(100% + 6px);
    height: calc(100% + 6px);
  }

  &__filename {
    font-weight: 500;
    color: $dark-grey;
    font-size: 14px;
  }
}
</style>
